<template>
  <n-dialog
    v-model="visible"
    custom-class="titan_dialog"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :primary-button="false"
    :secondary-button="false"
    width="1080px"
    size="huge"
    :show-close="false"
    @opened="afterOpen"
  >
    <div ref="refDom" class="micro-container">
      <MateEmpty status="loading" />
    </div>
  </n-dialog>
</template>
<script setup lang="ts">
import { ref, defineExpose } from 'vue';
import { NDialog } from '@nio-fe/lego';
import { setGlobalState } from '@/utils/micro';
import useMatestoreStore from '@/store/matestoreStore';
import { noticeMicro } from '@/utils/messageHandler';
import useGlobalStore from '@/store/globalStore';
import MateEmpty from '@/components/MateEmpty.vue';
import { MicroData } from '@/api/model/globalModel';

const matestoreStore = useMatestoreStore();
const globalStore = useGlobalStore();
let app: MicroData | undefined = undefined;
let appName = '';
let callback: Function | undefined = undefined;
let params: { [key: string]: any } | null = null;
const visible = ref<boolean>(false);
const refDom = ref(null);

async function init() {
  if (refDom.value) {
    const micro = await matestoreStore.activateMicroApp(
      appName,
      refDom.value,
      true
    );
    app = micro;
  }
}
/**
 * an: string, prm?: any, cb?: Function
 */
function onOpen(option: {
  appName: string;
  params?: any;
  callback?: Function;
}) {
  appName = option.appName;
  if (option.params) {
    params = { ...option.params };
  }
  callback = option.callback;
  visible.value = true;
}

function afterOpen() {
  // 打开 userinfo
  if (!app) {
    init();
  } else {
    if (app?._microAppInfo.getStatus() === 'MOUNTED') {
      setGlobalState({ name: appName, ...params });
    } else {
      console.error('微应用加载失败,重试：', app);
      init();
    }
  }
}

function onClose() {
  // if (accID) {
  //   if (callback) {
  //     callback(accID);
  //   } else {
  //     // @TODO 关闭跳转
  //     // const path = `${'/message'}?accountId=${accID}`;
  //     // router.push({ path, query: { accountId: accID } });
  //     globalStore.showFullScreenLoading(10 * 1000);
  //     matestoreStore.openImMicro();
  //
  //     noticeMicro('im', { action: 'openSingle', accountId: accID }, () => {
  //       globalStore.hideFullScreenLoading(300);
  //     });
  //   }
  // }
  visible.value = false;
}
defineExpose({ onOpen, onClose });
</script>
<style lang="scss" scoped>
.micro-container {
  min-height: 300px;
  :deep(> div) {
    height: 100%;
  }
}
</style>
